export * from './generateAlignmentClasses'
export * from './generateColorClasses'
export * from './generateFontClasses'
export * from './generateSpacingClasses'
export * from './backgroundImageMixin'
export * from './getMaxWidth'
export * from './getMinHeight'

export function bindStoryblokBridgeData(component) {
    const { _editable } = component || {}

    if (!_editable) return {}

    const blokOptions = JSON.parse(_editable.replace('<!--#storyblok#', '').replace('-->', ''))

    return {
        'data-blok-c': JSON.stringify(blokOptions),
        'data-blok-uid': blokOptions.id + '-' + blokOptions.uid,
    }
}

export function getScreenClassPrefix(mobileClass, tabletClass, desktopClass) {
    return [
        mobileClass,
        applyPrefixToClass('md:', tabletClass),
        applyPrefixToClass('lg:', desktopClass),
    ]
}

export function getUniversalLinkTarget(event) {
    let target = event.target
    // Elements like IMG that are inside an A tag will report the IMG not the A
    // .closest will look for the closest parent matching our selector
    if (event.target.tagName !== 'A')
        target = event.target.closest('[data-element-type="universalLink"]')

    // Early out if we don't find an A tag of elementType universalLink
    // Early out if we don't have an href
    if (target?.dataset?.elementType !== 'universalLink') return

    return target
}

function applyPrefixToClass(prefix, value) {
    if (!value) return
    return Array.isArray(value) ? value.map((val) => `${prefix}${val}`) : `${prefix}${value}`
}
